import Typography from '~/@/components/ui/typography'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'

export function NotificationEmptyState() {
  const { t } = useTypedTranslation()

  return (
    <div className="flex size-full flex-col items-center justify-center gap-6">
      <div
        className="size-36 bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/assets/empty-notifications.svg)',
        }}
      />
      <Typography color="text-gray-8" variant="body2">
        {t('notification_empty_state.title')}
      </Typography>
    </div>
  )
}
